import * as Sentry from '@sentry/browser';
import posthog from 'posthog-js';

import { DOMAIN } from 'data/constants';

import { AnalyticsUserEvent } from './types/AnalyticsUserEvent';

export function initPosthogProvider() {
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) return null;

  try {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
      api_host: `https://a.${DOMAIN}`,
      ui_host: 'https://us.posthog.com',
      defaults: '2026-01-30',
      loaded: (posthog) => {
        if (process.env.NODE_ENV === 'development') posthog.debug();
      },
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return {
    async track(event: AnalyticsUserEvent) {
      try {
        const timeFromPageLoad = performance.now();

        posthog.capture(
          event.type,
          {
            ...event.payload,
            time_from_page_load_seconds: Math.round(timeFromPageLoad / 1000),
          },
          { send_instantly: true },
        );
      } catch (error) {
        Sentry.captureException(error);
      }
    },

    async identify() {
      return;
    },

    async reset() {
      return;
    },
  };
}
